import React, { useEffect, useState } from "react";

const withResetLink = (WrappedComponent) => {
  return ({ initialTime = 120, ...props }) => {
    const [time, setTime] = useState(initialTime);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
      if (!isRunning || time <= 0) {
        return;
      }

      const timer = setInterval(() => {
        setTime((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setIsRunning(false);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }, [isRunning, time]);

    // Function to format time as MM:SS
    const formatTime = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    };

    const startTimer = () => {
      if (!isRunning) {
        setTime(initialTime)
        setIsRunning(true);
      }
    };

    return (
      <WrappedComponent
        {...props}
        time={formatTime(time)}
        resetLink={() => {
          setTime(initialTime);
          startTimer(false); 
        }}
        startTimer={startTimer}
        isRunning={isRunning}

      />
    );
  };
};

export default withResetLink;
